<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <h4>ราคาของสินค้าเฉลี่ยของแต่ละร้านค้า</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <GChart
                :data="chartData"
                :options="{
                  title: 'ราคาสินค้าเฉลี่ย',
                  pieHole: 0.5,
                  width: 600,
                  height: 600
                }"
                width="800"
                type="PieChart"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <table
            class="table"
            width="100%">
            <thead>
              <tr>
                <th style="font-size: 13px;">No.</th>
                <th style="font-size: 13px;">Shop Name</th>
                <th style="font-size: 13px;">Sku Count</th>
                <th style="font-size: 13px;">AVG Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in shopAvgProductPrice">
                <td>{{ (index+1) }}</td>
                <td>{{ item.shop_name }}</td>
                <td>{{ item.sku_count }}</td>
                <td>~ {{ item.price_avg > 0 ? item.price_avg.toFixed(0) : 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'ShopAvgProductPrice',

  components: {
    GChart,
  },

  data () {
    return {
      ready: false,
    }
  },

  computed: {
    shopAvgProductPrice () {
      return this.$store.getters['analytic/getState']('shopAvgProductPrice')
    },

    chartData () {
      let data = [
        ['Type', 'Count'],
        ['0-100', 0],
        ['101-500', 0],
        ['501-1000', 0],
        ['1001-5000', 0],
        ['>5000', 0],
      ]

      for (let item of this.shopAvgProductPrice) {
        let price = item.price_avg
        if (price <= 100) {
          data[1][1]++
        } else if (price <= 500) {
          data[2][1]++
        } else if (price <= 1000) {
          data[3][1]++
        } else if (price <= 5000) {
          data[4][1]++
        } else {
          data[5][1]++
        }
      }

      return data
    },
  },

  async created () {
    await this.$store.dispatch('analytic/getShopAvgProductPrice')
    this.ready = true
  },

}
</script>



// WEBPACK FOOTER //
// src/components/admin/analytics/ShopAvgProductPrice.vue